var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "26px",
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header_nav",
    transform: "translate(-20.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 375,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_monogram",
    transform: "translate(20.000000, 19.000000)",
    fill: "#302745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8 3.37230244e-14 8 9 20 9 20 3.37230244e-14 22 3.37230244e-14 22 20 20 20 20 11 8 11 8 20 6 20 6 3.37230244e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    transform: "translate(14.000000, 25.000000) rotate(-90.000000) translate(-14.000000, -25.000000) ",
    points: "13 11 15 11 15 39 13 39"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMonogram);
export default __webpack_public_path__ + "static/media/logo_monogram.603e5943.svg";
export { ForwardRef as ReactComponent };